var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29164 28C1.66144 28 1.12194 27.7824 0.673165 27.3472C0.224388 26.9121 0 26.3889 0 25.7778V11.6889C0 11.0778 0.224388 10.5546 0.673165 10.1194C1.12194 9.68426 1.66144 9.46667 2.29164 9.46667H4.35418V6.44443C4.35418 4.66148 5.00238 3.14167 6.29877 1.885C7.59519 0.628333 9.16308 0 11.0024 0C12.8418 0 14.4088 0.628333 15.7036 1.885C16.9984 3.14167 17.6458 4.66148 17.6458 6.44443V9.46667H19.7084C20.3386 9.46667 20.8781 9.68426 21.3268 10.1194C21.7756 10.5546 22 11.0778 22 11.6889V25.7778C22 26.3889 21.7756 26.9121 21.3268 27.3472C20.8781 27.7824 20.3386 28 19.7084 28H2.29164ZM2.29164 25.7778H19.7084V11.6889H2.29164V25.7778ZM11.0038 21.3333C11.7422 21.3333 12.3731 21.0831 12.8964 20.5826C13.4196 20.0822 13.6813 19.4805 13.6813 18.7778C13.6813 18.0889 13.4183 17.4759 12.8925 16.9389C12.3667 16.4019 11.7345 16.1333 10.9962 16.1333C10.2578 16.1333 9.62691 16.4019 9.10363 16.9389C8.58038 17.4759 8.31875 18.0926 8.31875 18.7889C8.31875 19.4852 8.58166 20.0833 9.10748 20.5833C9.63333 21.0833 10.2655 21.3333 11.0038 21.3333ZM6.64582 9.46667H15.3542V6.44443C15.3542 5.27159 14.9311 4.27468 14.085 3.4537C13.2389 2.6327 12.2114 2.2222 11.0027 2.2222C9.79394 2.2222 8.76561 2.6327 7.9177 3.4537C7.06978 4.27468 6.64582 5.27159 6.64582 6.44443V9.46667Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.06a7ec98acbaaec8f6eda48d1fe1f508.svg";
export { ForwardRef as ReactComponent };